import React, { useState } from 'react';

export default function TeamCardPreferencesPanel({
  cards = [],
  hiddenCardIds = new Set(),
  saving = false,
  onMoveCard,
  onToggleHidden,
  onShowAll,
  onReset,
}) {
  const [open, setOpen] = useState(false);
  const fixedCards = cards.filter((card) => card.fixed);
  const reorderableCards = cards.filter((card) => !card.fixed);
  const hiddenCount = reorderableCards.filter(
    (card) => hiddenCardIds.has(card.id) && card.hideable && !card.forceVisible
  ).length;

  return (
    <>
      <button
        type="button"
        className="button button-secondary button--sm nav-switch-trigger team-card-preferences__trigger"
        onClick={() => setOpen(true)}
      >
        Customize view
      </button>

      {open && (
        <div className="modal-backdrop" onClick={() => setOpen(false)}>
          <div
            className="modal-content team-card-preferences__modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="customize-view-title"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="team-card-preferences__modal-header">
              <div>
                <h2 id="customize-view-title" className="modal-title">
                  Customize view
                </h2>
                <div className="text-muted small">
                  Hide cards you rarely use and reorder the rest.
                </div>
              </div>
              <button
                type="button"
                className="btn btn--ghost btn--sm"
                onClick={() => setOpen(false)}
              >
                Close
              </button>
            </div>

            <div className="team-card-preferences__body">
              {fixedCards.length > 0 && (
                <div className="team-card-preferences__section">
                  <div className="team-card-preferences__heading">Pinned</div>
                  <div className="team-card-preferences__list">
                    {fixedCards.map((card) => (
                      <div key={card.id} className="team-card-preferences__item">
                        <div>
                          <strong>{card.label}</strong>
                          <div className="text-muted small">Always shown first.</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="team-card-preferences__section">
                <div className="team-card-preferences__heading">Card order</div>
                <div className="team-card-preferences__list">
                  {reorderableCards.length === 0 && (
                    <div className="text-muted small">No visible cards can be customized right now.</div>
                  )}
                  {reorderableCards.map((card, index) => {
                    const isHiddenByPreference = hiddenCardIds.has(card.id);
                    const forceVisible = Boolean(card.forceVisible);
                    const moveDisabledUp = index === 0;
                    const moveDisabledDown = index === reorderableCards.length - 1;

                    return (
                      <div key={card.id} className="team-card-preferences__item">
                        <div>
                          <strong>{card.label}</strong>
                          {forceVisible ? (
                            <div className="text-muted small">
                              Shown automatically while action is required.
                            </div>
                          ) : !card.hideable ? (
                            <div className="text-muted small">Always visible.</div>
                          ) : isHiddenByPreference ? (
                            <div className="text-muted small">Hidden.</div>
                          ) : null}
                        </div>

                        <div className="team-card-preferences__actions">
                          <button
                            type="button"
                            className="btn btn--ghost btn--xs"
                            onClick={() => onMoveCard?.(card.id, -1)}
                            disabled={saving || moveDisabledUp || !card.reorderable}
                          >
                            Up
                          </button>
                          <button
                            type="button"
                            className="btn btn--ghost btn--xs"
                            onClick={() => onMoveCard?.(card.id, 1)}
                            disabled={saving || moveDisabledDown || !card.reorderable}
                          >
                            Down
                          </button>
                          {card.hideable && (
                            <button
                              type="button"
                              className="btn btn--secondary btn--xs"
                              onClick={() => onToggleHidden?.(card.id, !isHiddenByPreference)}
                              disabled={saving}
                            >
                              {forceVisible
                                ? isHiddenByPreference
                                  ? 'Keep shown'
                                  : 'Hide when clear'
                                : isHiddenByPreference
                                  ? 'Show'
                                  : 'Hide'}
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="team-card-preferences__footer">
                {hiddenCount > 0 && (
                  <button
                    type="button"
                    className="btn btn--secondary btn--sm"
                    onClick={() => onShowAll?.()}
                    disabled={saving}
                  >
                    Show all
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn--ghost btn--sm"
                  onClick={() => onReset?.()}
                  disabled={saving}
                >
                  Reset layout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
